import { inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';

import { MainQuery } from '@shared/store/main/main.query';

@Injectable({ providedIn: 'root' })
export class QuarterCloseAdjustmentsService {
  private mainQuery = inject(MainQuery);

  formControlSelectedCategorySource = new BehaviorSubject<string>('');
  formControlSelectedMonthSource = new BehaviorSubject<string>('');
  formControlSelectedVendorSource = new BehaviorSubject<string[]>([]);
  selectedCategoryValue$ = this.formControlSelectedCategorySource.asObservable();
  selectedMonthValue$ = this.formControlSelectedMonthSource.asObservable();
  selectedVendorValue$ = this.formControlSelectedVendorSource.asObservable();

  constructor() {
    this.mainQuery
      .select('trialKey')
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.formControlSelectedVendorSource.next([]);
        this.formControlSelectedMonthSource.next('');
        this.formControlSelectedCategorySource.next('');
      });
  }

  updateFormControlValues(selectedMonth?: string, selectedVendor?: string[]) {
    if (selectedMonth) {
      this.formControlSelectedMonthSource.next(selectedMonth);
    }

    if (selectedVendor) {
      this.formControlSelectedVendorSource.next(selectedVendor);
    }
  }

  updateSelectCategory(selectedCategory: string): void {
    this.formControlSelectedCategorySource.next(selectedCategory);
  }
}
